<template>
  <section class="expanded-container">
    <div class="quotes-main-content">
      <template v-for="(item, index) in _.get(contentData, 'data.list')">
        <div class="quotes fade-up" v-in-viewport.once :key="index">
          <div class="quotes-content">
            <span
              class="quote-symbol f-kite"
              v-if="_.get(contentData, 'conf.conf[0]') == 'layout1'"
              >"</span
            >
            <h3
              class="font-34 text-overflow-hidden-2"
              :class="
                _.get(contentData, 'conf.conf[0]') != 'layout1'
                  ? 'header-margin'
                  : ''
              "
              v-if="item.title"
            >
              {{ item.title }}
            </h3>
            <div class="text" v-html="item.content"></div>
            <p class="font-21 text-overflow-hidden-1" v-if="item.author">
              {{ item.author }}
            </p>
          </div>
          <div class="img-box">
            <div class="img-mask"></div>
            <picture>
              <source
                class="img-absolute scale"
                media="(max-width: 767px)"
                :srcset="_.get(item, 'images[0].devices.mobile')"
              />
              <source
                class="img-absolute scale"
                media="(max-width: 1023px)"
                :srcset="_.get(item, 'images[0].devices.tablet')"
              />
              <img
                class="img-absolute scale"
                :src="_.get(item, 'images[0].devices.desktop')"
                :alt="_.get(item, 'images[0].title.title')"
              />
            </picture>
            <div class="mobile-title">
              <h3 class="font-34  relative" v-if="item.title">
                <span
                  class="quote-symbol f-kite"
                  v-if="_.get(contentData, 'conf.conf[0]') == 'layout1'"
                  >"</span
                >
                {{ item.title }}
              </h3>
            </div>
          </div>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
export default {
  props: ["contentData"],
  data() {
    return {};
  }
};
</script>
<style lang="scss">
.quotes-main-content {
  margin: 80px 0 30px;
  @media (max-width: 1679px) {
    margin: 55px 0 89px;
  }
  @media (max-width: 1023px) {
    margin: 34px 0 89px;
  }
  .quotes {
    display: flex;
    @media (max-width: 1023px) {
      flex-direction: column-reverse;
    }
    &:nth-child(odd) {
      justify-content: flex-end;
      $quotes: 10;
      margin-top: -100px;
      @media (max-width: 1679px) {
        margin-top: 55px;
      }
      .quotes-content {
        @media (min-width: 1700px) {
          max-width: 51%;
        }
        @media (max-width: 1365px) {
          max-width: 50%;
        }
        @media (max-width: 1023px) {
          max-width: 100%;
        }
      }
      h3 {
        margin-top: 53px;
      }
      .quote-symbol {
        top: 0%;
        @media (max-width: 1679px) {
          transform: translateY(-10%);
        }
      }
    }
    &:nth-child(1) {
      margin-top: 0px;

      @media (max-width: 1679px) {
        margin-top: 0;
      }
    }

    &:nth-child(even) {
      justify-content: start;
      flex-direction: row-reverse;
      margin-top: 0;
      @media (max-width: 1679px) {
        margin-top: 89px;
      }
      @media (max-width: 1023px) {
        flex-direction: column-reverse;
      }
      @media (max-width: 767px) {
        margin-top: 55px;
      }
      .img-box {
        margin-left: 0;
        margin-right: 30px;
        width: 51%;
        transform: translateY(-110px);
        overflow: hidden;
        position: relative;
        @media (max-width: 1679px) {
          transform: translateY(0);
          width: 51%;
          height: 454px;
        }
        @media (max-width: 1439px) {
          width: 51%;
          height: 430px;
        }
        @media (max-width: 1365px) {
          margin-right: 15px;
          width: 44%;
          height: 505px;
        }
        @media (max-width: 1023px) {
          margin-right: 0;
          width: 100%;
          height: 533px;
        }
        @media (max-width: 767px) {
          height: 337px;
        }
      }
      h3 {
        margin-top: 117px;
      }
      .quote-symbol {
        top: 5%;
        @media (max-width: 1679px) {
          transform: translateY(-10%);
        }
      }
      .quotes-content {
        @media (min-width: 1700px) {
          max-width: 47%;
        }
        @media (max-width: 1365px) {
          max-width: 50%;
        }
        @media (max-width: 1023px) {
          max-width: 100%;
          .quote-symbol,
          h3 {
            display: none;
          }
        }
      }
    }
    &:nth-child(2) {
      margin-top: 0px;
      @media (max-width: 1679px) {
        margin-top: 89px;
      }
      @media (max-width: 1023px) {
        flex-direction: column-reverse;
      }
      @media (max-width: 767px) {
        margin-top: 55px;
      }
    }
    .quotes-content {
      max-width: 555px;
      position: relative;
      @media (max-width: 1679px) {
        max-width: 441px;
        .text-overflow-hidden-2,
        .text-overflow-hidden-6 {
          -webkit-line-clamp: unset;
          line-clamp: unset;
        }
      }
      @media (max-width: 1439px) {
        max-width: 417px;
      }
      @media (max-width: 1365px) {
        max-width: 344.5px;
      }
      @media (max-width: 1023px) {
        width: 100%;
        max-width: 100%;
        padding: 0 34px;
        .quote-symbol,
        h3 {
          display: none;
        }
      }
      @media (max-width: 767px) {
        width: 100%;
        padding: 0 20px;
      }
      .quote-symbol {
        position: absolute;
        font-size: 144px;
        color: var(--red-txt);
        font-family: "Kite-Script" !important;
        @media (max-width: 1679px) {
          top: 0%;
          transform: translateY(-10%);
        }
      }
      h3 {
        color: var(--bonus-txt);
        width: fit-content;
        margin-bottom: 34px;
        &.header-margin {
          margin-top: 34px;
        }
        @media (max-width: 1679px) {
          margin-top: 34px;
        }
      }
      .text {
        color: var(--bonus-txt);
        line-height: 31px;
        margin-bottom: 34px;
        max-height: 280px;
        overflow: auto;
        padding-right: 10px;
        @media (max-width: 1599) {
          max-height: 250px;
        }
        &::-webkit-scrollbar {
          width: 5px;
          background: transparent;
        }
        &::-webkit-scrollbar-thumb {
          width: 5px;
          background: var(--primary);
          border-radius: 6px;
          cursor: pointer;
        }
        &::-webkit-scrollbar-track {
          width: 2px;
          background: var(--border);
        }
        @media (max-width: 1679px) {
          margin-bottom: 21px;
        }
        @media (max-width: 1023px) {
          max-height: unset;
        }
      }
      p {
        color: var(--bonus-txt);
      }
    }
    .img-box {
      margin-left: 30px;
      width: 47%;
      height: 610px;
      overflow: hidden;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        object-fit: cover;
      }
      .img-mask,
      .mobile-title {
        display: none;
      }
      @media (max-width: 1679px) {
        width: 47%;
        height: 468px;
      }
      @media (max-width: 1439px) {
        width: 46%;
        height: 442px;
      }
      @media (max-width: 1365px) {
        margin-left: 15px;
        width: 42%;
        height: 505px;
      }
      @media (max-width: 1023px) {
        margin-left: 0;
        width: 100%;
        height: 533px;
        margin-bottom: 21px;
        .img-mask {
          position: absolute;
          display: block;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          background: rgba(13, 19, 23, 0.5);
        }
        .mobile-title {
          display: block;
          position: absolute;
          z-index: 2;
          top: 0;
          width: 100%;
          height: 100%;
          h3 {
            position: absolute;
            bottom: 0;
            left: 0;
            color: var(--white-no-blue);
            margin-bottom: 34px;
            padding: 0 34px;
            -webkit-line-clamp: 4;
            @media (max-width: 767px) {
              padding: 0 20px;
            }
          }
          .quote-symbol {
            position: absolute;
            font-size: 144px;
            color: var(--red-txt);
            z-index: 2;
            top: 0;
            transform: translateY(-50%);
            left: 34px;
            @media (max-width: 767px) {
              left: 20px;
            }
          }
        }
      }
      @media (max-width: 767px) {
        height: 337px;
      }
    }
  }
}
</style>
